__turbopack_context__.v({
  "AgencyteamSection": "TeamHalfTextHalfMap-module-scss-module__HznHqG__AgencyteamSection",
  "address": "TeamHalfTextHalfMap-module-scss-module__HznHqG__address",
  "insuranceHalfTextHalfMap": "TeamHalfTextHalfMap-module-scss-module__HznHqG__insuranceHalfTextHalfMap",
  "mapContainer": "TeamHalfTextHalfMap-module-scss-module__HznHqG__mapContainer",
  "mapSection": "TeamHalfTextHalfMap-module-scss-module__HznHqG__mapSection",
  "mapWrapper": "TeamHalfTextHalfMap-module-scss-module__HznHqG__mapWrapper",
  "textSection": "TeamHalfTextHalfMap-module-scss-module__HznHqG__textSection",
});
